<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';
	import { toNewProgramStructureSignUpSheet } from '../../../domain/SheetData.ts';

	let { teaserContent }: {
		teaserContent: TeaserContent
	} = $props();

	const teaserSize = 'MediaObject25';
	const teaserType = TeaserType.BOOSTER_TEASER;
	const isBoosterTeaser = true;

	let headline = $state(teaserContent.heading);

	let teaser: Element;
	let trackingService: TrackingService;
	const sheetData: string = getSheetData();

	function getSheetData() {
		return JSON.stringify(toNewProgramStructureSignUpSheet(teaserType, teaserContent, TeaserTouchPoint.DETAILVIEW));
	}

	onMount(() => {
		trackingService = new TrackingService();
		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize, isBoosterTeaser);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize, isBoosterTeaser);
	});
</script>

<oc-block-v2
	style="--background-color:var(--oc-semantic-color-background-soft-pink); --custom-spacing-y: 0px; --custom-spacing-x: 0px;"
	bind:this={teaser}
	data-oc-sheet-v1-create={sheetData}
	data-testid="up-teaser-s-container"
	id="teaser-container"
	onenterViewport={() => trackSeen(trackingService)}
	use:onViewport>
	<div class="up-teaser-container">
		<oc-icon-v1 size="100" data-testid="icon_otto-voucher" type="voucher"></oc-icon-v1>
		<div class="up-teaser-container__headline">
			<span class="oc-headline-50">{headline}</span>
			<oc-link-v2 as-button="" size="75 " variant="underlined">{teaserContent?.subheading}</oc-link-v2>
		</div>
	</div>
</oc-block-v2>


<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .up-teaser-container {
		display: flex;
		gap: 16px;
		padding: 16px;
    cursor: pointer;

		&__headline {
      display: flex;
      flex-direction: column;
		}
  }

</style>
